<script src="delivery-dashboard.component.ts"></script>
<div class="dashboard-container container-fluid px-4 py-3">

    <!-- Stat Cards -->
    <div class="stats-cards mb3">

        <!-- Total stat card -->
        <div class="stat-card shadow-sm">
            <div class="stat-icon">🚚</div>
            <div class="stat-info">
                <div class="stat-count">{{ totalDeliveries }}</div>
                <div class="stat-label">Total Deliveries</div>
            </div>
        </div>

        <!-- Successful stat card -->
        <div class="stat-card shadow-sm">
            <div class="stat-icon text-success">
                <i class="bi bi-check-circle"></i>
            </div>
            <div class="stat-info">
                <div class="stat-count">{{ successfulDeliveries }}</div>
                <div class="stat-label">Successful</div>
            </div>
        </div>

        <!-- Not Successful stat card -->
        <div class="stat-card shadow-sm">
            <div class="stat-icon">❌</div>
            <div class="stat-info">
                <div class="stat-count">{{ failedDeliveries }}</div>
                <div class="stat-label">Not Successful</div>
            </div>
        </div>

        <!-- Due Stat Card-->
        <div class="stat-card shadow-sm">
            <div class="stat-icon">⏳</div>
            <div class="stat-info">
                <div class="stat-count">{{ dueDeliveries }}</div>
                <div class="stat-label">Due</div>
            </div>
        </div>

        <!-- Missed Stat Card-->
        <div class="stat-card shadow-sm">
            <div class="stat-icon text-warning">
                <mat-icon color="warn">cancel_schedule_send</mat-icon>
            </div>
            <div class="stat-info">
                <div class="stat-count">{{ missedDeliveries }}</div>
                <div class="stat-label">Missed</div>
            </div>
        </div>

    </div>

    <form
            [formGroup]="filterForm"
            (ngSubmit)="applyFilters()"
            class="filter-grid"
    >

            <div class="filter-col">
                <!-- Facility Name (labelled "Warehouse Name" for RW) -->
                <mat-form-field appearance="outline" class="w-100 meta-row">
                    <mat-label>{{ isRwTenant ? 'Warehouse Name' : 'Facility Name' }}</mat-label>
                    <input matInput placeholder="{{ isRwTenant ? 'Warehouse Name' : 'Facility Name' }}" formControlName="facility_name"/>
                </mat-form-field>

                <!-- CCC Number -->
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>
                        @if (isRwTenant) { Client ID } @else { CCC Number }
                    </mat-label>

                    <input matInput placeholder="{{ isRwTenant ? 'Client ID' : 'CCC Number' }}" formControlName="ccc"/>

                </mat-form-field>
            </div>



            <div class="filter-col">
                <!-- Refill Date Range-->
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Refill Date Range</mat-label>

                    <mat-date-range-input [rangePicker]="refillRangePicker" [formGroup]="filterForm">
                        <input matStartDate formControlName="refill_start_date" placeholder="Start date">
                        <input matEndDate   formControlName="refill_end_date"   placeholder="End date">
                    </mat-date-range-input>

                    <mat-datepicker-toggle matSuffix [for]="refillRangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #refillRangePicker></mat-date-range-picker>
                </mat-form-field>

                <!-- Preferred Delivery Date Range-->
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Preferred Delivery Date Range</mat-label>

                    <mat-date-range-input [rangePicker]="preferredDelRangePicker" [formGroup]="filterForm">
                        <input matStartDate formControlName="prefered_delivery_start_date" placeholder="Start date">
                        <input matEndDate   formControlName="prefered_delivery_end_date"   placeholder="End date">
                    </mat-date-range-input>

                    <mat-datepicker-toggle matSuffix [for]="preferredDelRangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #preferredDelRangePicker></mat-date-range-picker>
                </mat-form-field>
            </div>



            <div class="filter-col">
                <!-- Actual Delivery Date Range-->
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Actual Delivery Date Range</mat-label>

                    <mat-date-range-input [rangePicker]="actualDelRangePicker" [formGroup]="filterForm">
                        <input matStartDate formControlName="actual_delivery_start_date" placeholder="Start date">
                        <input matEndDate   formControlName="actual_delivery_end_date"   placeholder="End date">
                    </mat-date-range-input>

                    <mat-datepicker-toggle matSuffix [for]="actualDelRangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #actualDelRangePicker></mat-date-range-picker>
                </mat-form-field>

                <!-- Delivery Outcome -->
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Delivery Outcome</mat-label>
                    <mat-select formControlName="delivery_outcome">
                        <mat-option value="">All Outcomes</mat-option>
                        <mat-option value="Successful">Successful</mat-option>
                        <mat-option value="Not Successful">Not Successful</mat-option>
                        <mat-option value="delivered">Delivered</mat-option>
                        <mat-option value="Due">Due</mat-option>
                        <mat-option value="Missed">Missed</mat-option>
                        <mat-option value="Pending">Pending</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Carg Filter for KE/ZA; Dynamics Order # for RW (RW orders don't carry a group name) -->
            <div class="filter-col">
                @if (isRwTenant) {
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Order #</mat-label>
                    <input matInput placeholder="e.g. RW/SO/25/00330" formControlName="dynamics_order_number"/>
                </mat-form-field>
                } @else {
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Group Name</mat-label>
                    <input
                            matInput
                            placeholder="Group Name"
                            formControlName="carg"
                            [matAutocomplete]="auto"
                    />
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayCargName"
                    >
                        <mat-option *ngFor="let carg of cargGroups"
                                    [value]="carg">
                            {{ carg.group_name }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                }

                <!-- Form Buttons -->
                <div class="filter-actions">
                        <button mat-raised-button color="primary" type="submit">
                            <mat-icon class="me-1">filter_alt</mat-icon>
                            Apply
                        </button>
                        <button mat-raised-button color="warn" type="button" (click)="resetFilters()">
                            <mat-icon class="me-1">refresh</mat-icon>
                            Reset
                        </button>
                        <button mat-raised-button color="primary" type="button" (click)="downloadReport()">
                            <mat-icon class="me-1">download</mat-icon>
                            Report
                        </button>
                </div>

            </div>




    </form>
    <!-- Optional progress -->
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <!-- Table -->
    <div class="table-responsive">
        <table *ngIf="!isLoading" class="table table-striped" id="delivery_grid">
            <thead class="table-light">
            <tr>
                <th>@if (isRwTenant) { Warehouse Name } @else { Facility Name }</th>
                <th>@if (orgId == environment.biNcdID) {
                    Patient ID
                } @else if (isRwTenant) {
                    Client ID
                } @else {
                    CCC#
                }</th>
                @if (isRwTenant) {
                    <th>Order #</th>
                }
                <th>Enrolment Date</th>
                <th>Drug Refill<br/>Date (TCA)</th>
                <th>Preferred<br/>Delivery Date</th>
                <th>Delivery Type</th>
                @if (!isRwTenant) {
                    <th>Group Name</th>
                }
                <th>Number of<br>Clients</th>
                <th>Delivery<br>Attempts</th>
                <th>Actual<br/>Delivery Date</th>
                <th>Delivery<br/>Coordinates</th>
                <th>Delivery<br/>Outcome</th>
                <th>Delivery<br/>Time</th>
                <th>Returned<br/>To Site</th>
                <th>Name of Rider</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let delivery of filteredDeliveries">
                <tr
                        class="data-row"
                        [class.expandable]="delivery.attempt_count > 1"
                        [class.expanded]="expandedRow === delivery"
                        (click)="canExpand(delivery) && toggleRow(delivery)"
                >
                    <td>
                        <ng-container *ngIf="canExpand(delivery)">
                            <span class="expand-icon">
                              {{ expandedRow === delivery ? '▼' : '▶' }}
                            </span>
                        </ng-container>
                        {{ delivery.facility_name }}
                    </td>
                    <td>{{ delivery.ccc }}</td>
                    @if (isRwTenant) {
                        <td>{{ delivery.dynamics_order_no }}</td>
                    }
                    <td>{{ delivery.enrolment_date }}</td>
                    <td>{{ delivery.drug_refill_date }}</td>
                    <td>{{ delivery.prefered_delivery_date }}</td>
                    <td>{{ delivery.delivery_type }}</td>
                    @if (!isRwTenant) {
                        <td>{{ delivery.group_name }}</td>
                    }
                    <td>{{ delivery.client_count }}</td>
                    <td>
                        {{ delivery.attempt_count }}
                    </td>
                    <td>{{ delivery.actual_delivery_date }}</td>
                    <td>{{ delivery.actual_delivery_location }}</td>
                    <td>
            <span class="delivery-status"
                  [ngClass]="{
                'status-successful': delivery.delivery_outcome?.toLowerCase() === 'successful',
                'status-not-successful': delivery.delivery_outcome?.toLowerCase() === 'not successful',
                'status-delivered': delivery.delivery_outcome?.toLowerCase() === 'delivered',
                'status-forecasted': delivery.delivery_outcome?.toLowerCase() === 'forecasted',
                'status-pending': delivery.delivery_outcome?.toLowerCase() === 'pending',
                'status-due': delivery.delivery_outcome?.toLowerCase() === 'due',
                'status-missed': delivery.delivery_outcome?.toLowerCase() === 'missed'
              }"
            >
            {{ getDisplayOutcome(delivery.delivery_outcome) }}
            </span>
                    </td>
                    <td>{{ delivery.delivery_time }}</td>
                    <td>{{ delivery.medication_returned }}</td>
                    <td>{{ delivery.name_of_rider }}</td>
                    <td>
                        <button
                                class="btn btn-sm btn-outline-secondary"
                                title="Edit"
                                [ngClass]="{
                        'btn-outline-magenta': isEditableStatus(delivery.delivery_outcome),
                        'btn-outline-secondary': !isEditableStatus(delivery.delivery_outcome)
                      }"
                                [disabled]="!isEditableStatus(delivery.delivery_outcome)"
                                (click)="openEditModal(delivery)">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                    </td>
                </tr>
                <!-- expansion row -->
                <tr *ngIf="expandedRow === delivery">
                    <td colspan="16">
                        <table class="table history-table">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Delivery Outcome</th>
                                <th>Delivery Date</th>
                                <th>Delivery Time</th>
                                <th>Delivery Coordinates</th>
                                <th>Rider</th>
                                <th>Comments</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let attempt of delivery.history; let i =index">
                                <td>{{ i + 1 }}</td>
                                <td>
                                <span class="delivery-status"
                                      [ngClass]="{
                                    'status-successful': attempt.delivery_outcome?.toLowerCase() === 'successful',
                                    'status-not-successful': attempt.delivery_outcome?.toLowerCase() === 'not successful'
                                  }"
                                >
                                {{ getDisplayOutcome(attempt.delivery_outcome) }}
                                </span>
                                </td>
                                <td>{{ attempt.actual_delivery_date }}</td>
                                <td>{{ attempt.delivery_time }}</td>
                                <td>{{ attempt.delivery_geocoordinates }}</td>
                                <td>{{ attempt.name_of_rider }}</td>
                                <td>{{ attempt.contact_of_rider }}</td>
                                <td>{{ attempt.comments }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

            </ng-container>

            </tbody>
        </table>

        <!--Pagination controls-->
        <div class="pagination">
            <button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
        </div>
    </div>


</div>